// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".a[data-v-12ee6a86]{fill:none}.b[data-v-12ee6a86]{-webkit-clip-path:url(#a);clip-path:url(#a)}.c[data-v-12ee6a86]{fill:#707070}", ""]);
// Exports
module.exports = exports;
